"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var CtkWidget = function (_a) {
    var _b, _c;
    var data = _a.data, renderEmpty = _a.renderEmpty;
    var _d = React.useState(''), loadError = _d[0], setLoadError = _d[1];
    var LOAD_PYM_JS_EVENT = 'loadPymJs';
    var viewUrl = (_b = data === null || data === void 0 ? void 0 : data.viewUrl) !== null && _b !== void 0 ? _b : '';
    var ctkWidgetType = (_c = data === null || data === void 0 ? void 0 : data.ctkWidgetType) !== null && _c !== void 0 ? _c : '';
    var elementId = 'ctk-widget'; // data?.elementId;
    React.useLayoutEffect(function () {
        var _a;
        if (!viewUrl || !elementId || !ctkWidgetType) {
            return;
        }
        var src = "https://widget.ctk.cz/" + data.ctkWidgetType + "/pym.js";
        var scriptAttributes = {
            id: "ctk-widget-" + ctkWidgetType,
            type: 'text/javascript',
            src: src,
            onload: function () {
                var event = new Event(LOAD_PYM_JS_EVENT);
                document.dispatchEvent(event);
            },
            onerror: function () {
                setLoadError("Nepodarilo sa na\u010D\u00EDta\u0165 zdrojov\u00E9 s\u00FAbory pre spustenie widgetu!");
            }
        };
        if (!document.querySelector("#" + scriptAttributes.id) &&
            scriptAttributes.src) {
            var newScript_1 = document.createElement('script');
            Object.keys(scriptAttributes).forEach(function (key) {
                newScript_1[key] = scriptAttributes[key];
            });
            document.body.appendChild(newScript_1);
        }
        var initCtkWidget = function () {
            try {
                var runScript = document.createElement('script');
                runScript.id = "ctk-widget-" + elementId;
                runScript.text = "new pym.Parent('" + elementId + "', '" + viewUrl + "', {})";
                runScript.type = 'text/javascript';
                document.body.appendChild(runScript);
            }
            catch (err) {
                console.error(err); // tslint:disable-line:no-console
            }
        };
        document.addEventListener(LOAD_PYM_JS_EVENT, initCtkWidget, false);
        // ak sa meni widget v editore ...
        if ((_a = window) === null || _a === void 0 ? void 0 : _a.pym) {
            initCtkWidget();
        }
        return function () {
            document.removeEventListener(LOAD_PYM_JS_EVENT, initCtkWidget, false);
            var pymElement = document.querySelector("#" + scriptAttributes.id);
            pymElement === null || pymElement === void 0 ? void 0 : pymElement.remove();
            var scriptElement = document.querySelector("#ctk-widget-" + elementId);
            scriptElement === null || scriptElement === void 0 ? void 0 : scriptElement.remove();
        };
    }, [viewUrl, elementId, ctkWidgetType]);
    if (!viewUrl || !ctkWidgetType) {
        return renderEmpty ? renderEmpty('ctk-widget') : null;
    }
    return (React.createElement("div", { key: elementId, id: elementId }, loadError));
};
exports["default"] = React.memo(CtkWidget);
